import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { useUserStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMenuButton',
  setup(__props) {

const { isLoggedIn } = useUserStore();
const loading = ref(false);

function onWillDismiss() {
	loading.value = false;
}

async function handleLoginClick() {
	loading.value = true;

	if (isLoggedIn.value) {
		await ModalHelper.openModal(SettingsModal, { closable: true, onWillDismiss });
	} else {
		await ModalHelper.openModal(
			AccountModal,
			{ closable: true, onWillDismiss },
			{ cssClass: 'account-modal' },
			'LoginMenuButton'
		);
	}
}

return { __sfc: true,isLoggedIn, loading, onWillDismiss, handleLoginClick, faUserCog }
}

})